module.exports = [{"name":"Data Processing Addendum (DPA - Editable)","papers":[{"title":"Data Processing Addendum","id":"auth0-dpa-editable","icon":"https://cdn.auth0.com/website/assets/pages/legals/img/icon-word-92c794e490.svg","date":"January, 2019","actions":[{"action":"download","file":"https://cdn.auth0.com/website/legal/files/auth0-dpa-editable-19.docx"}]}]}]


//////////////////
// WEBPACK FOOTER
// ./src/pages/legals/dpa-editable/data/dpaPapers.json
// module id = 1526
// module chunks = 0